// axios 发送ajax请求
import request from '@/utils/request'

export default{

  //发起支付请求
  tradePagePay(productId,account,count) {
    return request({
      url: '/public/api/ali-pay/trade/page/pay/' + productId+'/' +account+'/' +count,
      method: 'post'
    })
  },

  cancel(orderNo) {
    return request({
      url: '/public/api/ali-pay/trade/close/' + orderNo,
      method: 'post'
    })
  },

  refunds(orderNo, reason) {
    return request({
      url: '/public/api/ali-pay/trade/refund/' + orderNo + '/' + reason,
      method: 'post'
    })
  },
  tradePagePay1(productId,account,count) {
    return request({
      url: '/public/api/ali-pay/trade/page/pay1/' + productId+'/' +account+'/' +count,
      method: 'post'
    })
  },

  cancel1(orderNo) {
    return request({
      url: '/public/api/ali-pay/trade/close1/' + orderNo,
      method: 'post'
    })
  },

  refunds1(orderNo, reason) {
    return request({
      url: '/public/api/ali-pay/trade/refund1/' + orderNo + '/' + reason,
      method: 'post'
    })
  }
}
